import axios from 'axios';
import { baseUrl } from '../helpers/api.js';
import { modal } from './modal';

const CancelToken = axios.CancelToken;
// key is an URL, value is cancel token
const axiosLoadingRequests = {};
// const locale = getMeta('locale');
const error404en = 'Record not found';
const error401en = 'Unauthorized';
const error403en = 'You do not have access rights';
const error500en = 'Internal server error';
const error429en = 'Too many requests. Please try again in one minute.';

const error404fr = 'Enregistrement non trouvé';
const error401fr = 'Non autorisé';
const error403fr = 'Vous n\'avez pas de droits d\'accès';
const error500fr = 'Internal server error';
const error429fr = 'Trop de requêtes. Merci de réessayer dans une minute.';

export async function axiosCall (args) {
    const {
        url,
        params,
        data,
        method,
        cancelToken,
    } = args;

    const baseURL = baseUrl;

    return new Promise(async (resolve, reject) => {
        try {
            const cancelSource = CancelToken.source();

            // If request to this url is already running -> Cancel him
            if (axiosLoadingRequests[url]) {
                axiosLoadingRequests[url].cancel();
            }

            axiosLoadingRequests[url] = cancelSource;

            const response = await axios({
                baseURL,
                url,
                responseType: 'json',
                cancelToken: cancelToken || cancelSource.token,
                method: method || 'get',
                params,
                data,
            });

            delete axiosLoadingRequests[url];
            resolve(response.data);
        } catch (error) {
            if (!axios.isCancel(error)) {
                reject(error);
            }
        }
    });
}

axios.interceptors.response.use(response => {
    return response;
}, error => {
    const locale = localStorage.getItem('locale');
    if (error && error.response) {
        if (error.response.status === 404) {
            modal('error', locale === 'en' ? error404en : error404fr);
        } else if (error.response.status === 401) {
            modal('error', locale === 'en' ? error401en : error401fr);
        } else if (error.response.status === 403) {
            modal('error', locale === 'en' ? error403en : error403fr);
        } else if (error.response.status === 500) {
            modal('error', locale === 'en' ? error500en : error500fr);
        } else if (error.response.status === 429) {
            modal('error', locale === 'en' ? error429en : error429fr);
        }
    }
    return Promise.reject(error);
});
